// Daily rotating items for the "Today on the Trail" homepage strip.
// Selected deterministically by UTC day-of-week (0–6) so all visitors see the
// same item on the same day. No backend, no API call — pure static data.
//
// Each entry's `href` MUST resolve to an existing locale-aware route
// (handled by LocaleLink) or an existing static path. i18n-bound copy lives
// under the `dailyTrail.items.<index>.{label,message}` keys.
export interface DailyTrailItem {
  /** lucide icon name — resolved at component render */
  icon:
    | "sparkles"
    | "newspaper"
    | "shield-check"
    | "trending-up"
    | "compass"
    | "rocket"
    | "graduation-cap";
  /** Locale-aware path (e.g. "/whats-new", "/insights") */
  href: string;
}

// Order is significant — index = (UTC day - 1) mod 7, Mon=0 .. Sun=6.
export const DAILY_TRAIL_ITEMS: DailyTrailItem[] = [
  // Monday — kick off the week with a release note
  { icon: "rocket", href: "/whats-new" },
  // Tuesday — deep insight
  { icon: "newspaper", href: "/insights" },
  // Wednesday — framework spotlight
  { icon: "shield-check", href: "/framework-library" },
  // Thursday — ROI / business case
  { icon: "trending-up", href: "/roi-calculator" },
  // Friday — readiness check
  { icon: "compass", href: "/readiness" },
  // Saturday — guide / learning
  { icon: "graduation-cap", href: "/resources" },
  // Sunday — fresh from the team
  { icon: "sparkles", href: "/insights" },
];

/** Returns the item to feature today, deterministic per UTC day. */
export function pickTodayItem(now: Date = new Date()): {
  item: DailyTrailItem;
  index: number;
} {
  // getUTCDay: Sun=0..Sat=6. Convert so Mon=0..Sun=6.
  const dow = now.getUTCDay();
  const idx = (dow + 6) % 7;
  return { item: DAILY_TRAIL_ITEMS[idx], index: idx };
}
